import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lift-detail-menu',
  templateUrl: './lift-detail-menu.component.html',
  styleUrls: ['./lift-detail-menu.component.css']
})
export class LiftDetailMenuComponent implements OnInit {

  @Input()
  menu = 'basic';

  @Input()
  canView = false;

  @Input()
  canViewErrors = false;

  @Input()
  canControl = false;

  @Input()
  canViewParameter = false;

  @Input()
  liftId: number;

  constructor(
    public translateService: TranslateService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  goToState() {
    /*if (this.menu == 'state') {
      return;
    }*/
    this.router.navigate([{ outlets: { modal: ['lift-state', this.liftId] } }]);
  }

  goToErrors() {
    this.router.navigate([{ outlets: { modal: ['lift-error', this.liftId] } }]);
  }

  goToDetail() {
    this.router.navigate([{ outlets: { modal: ['lift-detail', this.liftId] } }]);
  }

  goToRide() {
    this.router.navigate([{ outlets: { modal: ['lift-ride', this.liftId] } }]);
  }

  goToParameters() {
    this.router.navigate([{ outlets: { modal: ['lift-parameters', this.liftId] } }]);
  }

  goToController() {
    this.router.navigate([{ outlets: { modal: ['lift-controller', this.liftId] } }]);
  }

  goToConsumption() {
    this.router.navigate([{ outlets: { modal: ['lift-consumption', this.liftId] } }]);
  }

  goToTemperature() {
    this.router.navigate([{ outlets: { modal: ['lift-temperature', this.liftId] } }]);
  }

  onMenuChange(itemName: string) {
    if (itemName == 'basic') {
      this.goToDetail();
    }

    if (itemName == 'state') {
      this.goToState();
    }

    if (itemName == 'errors') {
      this.goToErrors();
    }

    if (itemName == 'ride') {
      this.goToRide();
    }

    if (itemName == 'param') {
      this.goToParameters();
    }

    if (itemName == 'controller') {
      this.goToController();
    }

    if (itemName == 'consum') {
      this.goToConsumption();
    }

    if (itemName == 'temp') {
      this.goToTemperature();
    }
  }
}
